module.exports = __webpack_public_path__ + "static/fatna-e527b04f54dc7af32287f8d4cb6dfd94.jpg";